var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.card, ( _obj = {}, _obj[_vm.$style.selected] = _vm.selected, _obj )]},[_c('div',{class:_vm.$style.cardImage},[_c('TwicImg',{class:_vm.$style.image,attrs:{"src":_vm.imageUrl,"height":"200","width":"200"}})],1),_c('div',{class:_vm.$style.textWrapper},[_vm._t("default"),_c('div',{class:_vm.$style.price},[_vm._t("price")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }